(function(){
  function setDropLink(selector,name,status,live){
    document.querySelectorAll(selector).forEach(function(link){
      link.classList.add('jj-menu-drop-link');
      link.innerHTML='<span class="jj-menu-drop-name">'+name+'</span><span class="jj-menu-drop-status'+(live?' jj-menu-drop-status--live':'')+'">'+status+'</span>';
    });
  }
  function setText(selector,text){
    var el=document.querySelector(selector);
    if(el) el.textContent=text;
  }
  function init(){
    setDropLink('.jj-drop-panel a[href="/pages/drop-001"], .jj-mobile-panel a[href="/pages/drop-001"]','DROP 001','DISPONIBLE',true);
    setDropLink('.jj-drop-panel a[href="/pages/drop-002"], .jj-mobile-panel a[href="/pages/drop-002"]','DROP 002','10/11/26',false);
    setDropLink('.jj-drop-panel a[href="/pages/drop-003"], .jj-mobile-panel a[href="/pages/drop-003"]','DROP 003','10/12/26',false);

    setText('.jj-current-drop .jj-current-head .jj-kicker','DROP 001 — AVAILABLE NOW');
    setText('.jj-drop002-preview .jj-current-head .jj-kicker','DROP 002 — AVAILABLE 10/11/2026');
    setText('.jj-drop-001-page > .jj-page-hero .jj-kicker','DROP 001 — AVAILABLE NOW');
    setText('.jj-drop-002-page > .jj-page-hero .jj-kicker','DROP 002 — AVAILABLE 10/11/2026');

    var drop3=document.querySelector('.jj-next-chapters a[href="/pages/drop-003"] .jj-drop-card-content small:last-child');
    if(drop3) drop3.textContent='TRACKSUITS / ENSEMBLES — AVAILABLE 10/12/2026';
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
